<template>
  <v-autocomplete
    :label="
      $t('fleet_management.agents.create.labels.create_agent_form_geofence')
    "
    v-model="selectedGeofence"
    :items="geofences"
    return-object
    :loading="loading"
    :disabled="loading"
    :readonly="!editMode"
    item-text="properties.name"
    deletable-chips
    hide-details="auto"
    required
    chips
    multiple
    color="tertiary"
    class="pt-0 mt-2"
    :rules="geofenceRules"
    no-data-text="No hay informacion"
    @input="geofenceEmit"
    filled
    dense
  >
       <template
                    v-slot:prepend-item
                 
                  >
                    <v-list-item ripple @click="selectAllItems">
                      <v-list-item-action>
                              <v-icon v-if="!selectAll">
                                             mdi-square-outline

                        </v-icon>
                        <v-icon v-else>
                                             mdi-close-box

                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Seleccionar todo
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider class="mt-2"></v-divider>
                  </template>

  
    <template v-slot:selection="{ item, index }">
      
          
      
      <v-chip v-if="index < 3">
  
        <span>{{ item.properties.name }}</span>
      </v-chip>
      <span v-else-if="index === 3" class="grey--text caption">
        (+{{ selectedGeofence.length - 3 }})
      </span>

    </template>
    <template v-slot:label>
      <span>Zonas</span>
      <span class="asterisc"> *</span>
    </template>
  </v-autocomplete>
</template>

<script>
import { GeofencesHelpers } from '@/helpers/mainExports.js'
import { mapGetters } from 'vuex'

export default {
  name: 'inGeofence',
  props: {
    editMode: {
      type: Boolean,
      default: false
    },
    dataProp: {
      default: []
    }
  },
  components: {},
  data() {
    return {
      loading: true,
      selectAll: false,
      geofences: [],
      selectedGeofence: [],
      geofenceRules: [v => v.length > 0 || 'Campo Obligatorio']
    }
  },
  methods: {
    async getGeofencesList() {
      const response = await GeofencesHelpers.getGeofences()
      this.loading = false
      if (!response.hasOwnProperty('error')) {
        const zones = response.map(item => {
          item.data.id = item.id
          return item.data
        })
        this.geofences = zones
      }
    },
    selectAllItems() {
      this.selectAll = !this.selectAll
      if(this.selectAll){
        this.selectedGeofence = this.geofences
      } else {
        this.selectedGeofence = []
      }
      this.geofenceEmit()
    },
    geofenceEmit() {
      const formGeofence = this.selectedGeofence
      const geofences = {}
      for (let index = 0; index < formGeofence.length; index++) {
        const element = formGeofence[index]
        const id = element.id
        const name = element.properties.name
        geofences[id] = name
      }
      console.log("formGeofence",formGeofence)

      this.dataProp = formGeofence

      this.$emit('geofenceEmit', this.dataProp)
    }
  },
  computed: {
    ...mapGetters('auth', ['connection'])
  },
  watch: {
    editMode() {
      if (this.editMode == false) {
        this.selectedGeofence = []
        this.dataProp.map(item => {
          const id = Object.keys(item)[0]
          const data = this.geofences.find(geofence => geofence.id === id)
          this.selectedGeofence.push(data)
        })
      }
    }
  },

  created() {
    console.log("creado")
    const connection = this.connection
    if (!connection.session.isOpen) {
      setTimeout(() => {
        this.$nextTick(function() {
          this.getGeofencesList().then(() => {
            this.dataProp.map(item => {
              const id = Object.keys(item)[0]
              const data = this.geofences.find(geofence => geofence.id === id)
              this.selectedGeofence.push(data)
              console.log("!conection", this.selectedGeofence)
            })
          })
        })
      }, 1000)
    } else {
        this.getGeofencesList().then(() => {
        console.log(this.dataProp)
        this.dataProp.map(item => {
          const id = Object.keys(item)[0]
          const data = this.geofences.find(geofence => geofence.id === id)
          this.selectedGeofence.push(data)
          console.log("conection", this.selectedGeofence)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>
